import { jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import cx from "classnames";
const Hyperlink = forwardRef(
  (props, ref) => {
    const {
      prefix = "",
      children,
      text = "",
      url = "#",
      subtle,
      disabled = false,
      button = false,
      colour,
      className,
      onClick,
      newWindow = false,
      ariaControls,
      ...otherProps
    } = props;
    function preventClick(e) {
      e.preventDefault();
    }
    const cssStyles = cx(
      className,
      `${prefix}link`,
      colour && `${prefix}link--${colour}`,
      subtle && `${prefix}link--subtle`,
      disabled && `${prefix}link--disabled`
    );
    let role = button ? "button" : void 0;
    role = disabled ? "link" : role;
    return (
      // eslint-disable-next-line react/jsx-no-target-blank
      /* @__PURE__ */ jsxs(
        "a",
        {
          ref,
          target: newWindow ? "_blank" : void 0,
          ...otherProps,
          href: !disabled ? url : void 0,
          className: cssStyles,
          role,
          "aria-disabled": disabled && `${disabled}`,
          "aria-controls": ariaControls ? ariaControls : void 0,
          onClick: button && disabled ? preventClick : onClick,
          children: [
            text,
            text && children ? " " : null,
            children
          ]
        }
      )
    );
  }
);
Hyperlink.displayName = "Hyperlink";
var Hyperlink_default = Hyperlink;
export {
  Hyperlink_default as default
};
